import { useEffect, useState } from 'react';

export const useDynamicLineClamp = ({ watchedRef, targetRef, targetContainerRef }) => {
    const [lineClamp, setLineClamp] = useState(2);

    useEffect(() => {
        const watchedElement = watchedRef.current;

        const updateLineClamp = () => {
            const targetElement = targetRef.current;
            const targetContainerElement = targetContainerRef.current;

            if (!targetElement || !targetContainerElement) {
                return;
            }

            const lineHeight = parseFloat(getComputedStyle(targetElement).lineHeight);
            const maxHeight = targetContainerElement.clientHeight;
            const computedLinesCount = Math.floor(maxHeight / lineHeight);
            setLineClamp(computedLinesCount);
        };

        const resizeObserver = new ResizeObserver(updateLineClamp);

        if (watchedElement) {
            resizeObserver.observe(watchedElement);
        }

        return () => {
            if (watchedElement) {
                resizeObserver.unobserve(watchedElement);
            }
        };
    }, []);

    return lineClamp;
};
